import { render, staticRenderFns } from "./BaseImageSlider.vue?vue&type=template&id=7c23a425&scoped=true&"
import script from "./BaseImageSlider.vue?vue&type=script&lang=js&"
export * from "./BaseImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageSlider.vue?vue&type=style&index=0&id=7c23a425&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23a425",
  null
  
)

export default component.exports